'use client';

import { createContext, use } from 'react';

import { type RendererOption } from '@/shared-project-response-message-renderers';
import { type Messages } from '@/shared-ui';
import { ProjectType } from '@/survey-graphql';

type ChatMessage = Messages[number];

export interface HandsFreeQuestionPopupContextValue {
  currentQuestionIndex: number;
  totalQuestions: number;
  message: ChatMessage;
  messageType: RendererOption;
  projectType?: ProjectType;
}

export const HandsFreeQuestionPopupContext =
  createContext<HandsFreeQuestionPopupContextValue | null>(null);

export function useHandsFreeQuestionPopupContext() {
  const ctx = use(HandsFreeQuestionPopupContext);
  if (!ctx) {
    throw new Error(
      'HandsFreeQuestionPopup subcomponents must be used inside <ProjectUsabilityHandsFreeQuestionPopup>'
    );
  }
  return ctx;
}
